module.exports = __webpack_public_path__ + "media/images/emblems/Ballens-coat_of_arms-a0369f74be85a7d32d9e0d3f08fe09d6.svg";